var $0e4ec1f16b052a8f$exports = {};
const $0e4ec1f16b052a8f$var$currentYearEl = document.getElementById('current-year');
if ($0e4ec1f16b052a8f$var$currentYearEl) $0e4ec1f16b052a8f$var$currentYearEl.textContent = String(new Date().getFullYear());


//# sourceMappingURL=main.303f42d3.js.map
